import React from "react";
import { Typography, CardContent } from "@mui/material";
import InfoIconButton from "./InfoIconButtonComponent";
import { ResponsivePie } from '@nivo/pie';

const CFASplitSection = ({ projectData }) => {
	const cfaStructure = projectData?.project_data?.cfa_structure || projectData?.cfa_structure;

	// Pie chart config (from old CFASplitComponent)
	const pieConfig = {
		margin: { top: 20, right: 115, bottom: 20, left: 115 },
		fit: true,
		innerRadius: 0.5,
		padAngle: 0.7,
		cornerRadius: 3,
		activeOuterRadiusOffset: 8,
		borderWidth: 1,
		borderColor: {
		from: 'color',
		modifiers: [ ['darker', 0.2] ]
		},
		arcLinkLabelsSkipAngle: 10,
		arcLinkLabelsTextColor: "#333333",
		arcLinkLabelsThickness: 2,
		arcLinkLabelsColor: { from: 'color' },
		arcLabelsSkipAngle: 10,
		arcLinkLabelsDiagonalLength: 10,
		arcLinkLabelsStraightLength: 10,
		arcLinkLabelsOffset: 0,
		arcLabelsTextColor: '#FFFFFF',
		defs: [
		{
			id: 'dots',
			type: 'patternDots',
			background: 'inherit',
			color: 'rgba(255, 255, 255, 0.3)',
			size: 4,
			padding: 1,
			stagger: true
		},
		{
			id: 'lines',
			type: 'patternLines',
			background: 'inherit',
			color: 'rgba(255, 255, 255, 0.3)',
			rotation: -45,
			lineWidth: 6,
			spacing: 10
		}
		],
		colors: ['rgba(9, 61, 97, 0.8)', 'rgba(0, 174, 239, 0.8)', 'rgba(165, 165, 165, 0.8)', 'rgba(0, 0, 0, 0.6)'],
		theme: {
		labels: {
			text: {
			fontSize: 14,
			fontFamily: 'Titillium Web, sans-serif',
			fill: '#ffffff'
			},
		},
		tooltip: {
			container: {
			fontSize: 14,
			fontFamily: 'Titillium Web, sans-serif',
			},
		},
		}
	};

	let chartContent;
	if (!cfaStructure) {
		chartContent = (
			<CardContent
				sx={{
				height: '100px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				}}
			>
				<Typography className="key-project-info-body">--</Typography>
			</CardContent>
		);
	} else {
		const data = Object.keys(cfaStructure).map((key) => ({
		id: key,
		value: cfaStructure[key],
		}));
		chartContent = (
		<div style={{ height: '100%', width: '100%', position: 'relative' }}>
			<ResponsivePie data={data} {...pieConfig} />
		</div>
		);
	}

	return (
		<>
		<div className="card-content-header card-content-header-padded">
			<Typography
				variant="subtitle1"
				className="card-title"
				sx={{ textAlign: "left", verticalAlign: "top" }}
			>
				CFA Split
			</Typography>
			<InfoIconButton projectData={projectData} source="salesforce" />
		</div>
		<div style={{ height: "100%", minHeight: "100px", maxHeight: "150px" }}>
			{chartContent}
		</div>
		</>
	);
};

export default CFASplitSection;
